import axios from '@axios'
import moment from 'moment'

const getInitialState = () => ({
  filters: {
    storeId: null,
    checkingAccountId: null,
  },
  balance: null,
  consultedAt: null,
})

export default {
  namespaced: true,
  state: getInitialState(),

  mutations: {
    SET_BALANCE(state, balance) {
      state.balance = balance
    },
    SET_CONSULTED_AT(state, consultedAt) {
      state.consultedAt = consultedAt
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { filters, balance, consultedAt } = getInitialState()
      state.filters = filters
      state.balance = balance
      state.consultedAt = consultedAt
    },
  },

  actions: {
    async fetchBalance({ commit, state }) {
      const { checkingAccountId } = state.filters

      const { data } = await axios.get('/api/financial/internet-banking/accounts/balance', {
        params: { checkingAccountId },
      })

      commit('SET_BALANCE', data)
      commit('SET_CONSULTED_AT', moment().format())
    },

    resetFilters({ commit }) {
      commit('CLEAN_STATE')
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
